import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { BreakPointDesktop } from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    height: 70,
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "space-between",
    position: "fixed",
    width: "-webkit-fill-available",
    top: 0,
    left: 0,
    zIndex: theme.zIndex.appBar + 1,
    alignItems: "center",
    padding: theme.spacing.space16,
    paddingTop: theme.spacing.space16,
    paddingLeft: theme.spacing.space16,
    background: "linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
    [BreakPointDesktop]: {
      display: "none",
    },
  },
  centerContent: {
    position: "absolute",
    left: "50%",
    transform: "translate(-50%)",
  },
  leftContent: {},
  rightContent: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space16,
  },
  logo: {
    width: "auto",
    height: 25,
  },
  gamepad: {
    position: "relative",
    padding: "2px 0",
    paddingTop: 12,
  },
  totalGamepad: {
    position: "absolute",
    top: 0,
    right: 0,
    borderRadius: 2,
    background: "#1877EB",
    width: 16,
    height: 16,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 8,
    fontStyle: "normal",
    fontWeight: 600,
    color: "#FFFFFF",
  },
  avatar: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  selected: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: 2,
    borderRadius: theme.spacing.space20,
  },
  avatarImage: {
    position: "relative",
    display: "flex",
  },
  userStatus: {
    top: 0,
    right: 0,
    width: 12,
    height: 12,
    display: "flex",
    position: "absolute",
    zIndex: 1,
    borderRadius: "50%",
    "&.not-subscribed": {
      background: theme.colors.TextGray,
    },
    "&.expire-soon": {
      background: theme.colors.NotificationWarning,
    },
    "&.grace": {
      background: theme.colors.NotificationWarning,
    },
    "&.subscribed": {
      background: theme.colors.NotificationSuccess,
    },
    "&.expired": {
      background: theme.colors.NotificationError,
    },
  },
}));
